import { useTranslation } from 'react-i18next';
import { useUserStore } from 'src/store/user-store';
import { useEffect, useRef, useState } from 'react';
import { IconButton, useTheme } from '@mui/material';
import AppsIcon from '@mui/icons-material/Apps';

export default function MarketplaceTrigger() {
  const [open, setOpen] = useState<boolean>(false);

  const { i18n } = useTranslation();

  const { viewContext } = useUserStore();

  const theme = useTheme();

  const { mode } = theme.palette;

  const isDevEnvironment = import.meta.env.DEV;

  const shortEnvName = isDevEnvironment ? 'dev' : 'prod';

  const iframeRef = useRef<HTMLIFrameElement>(null);

  const message = {
    theme: mode,
    view: viewContext,
    env: shortEnvName,
    locale: i18n.language,
  };

  const sendMessage = () => {
    iframeRef.current?.contentWindow?.postMessage(message, '*');
  };

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const open = event.data?.open;
      setOpen(open);
    };

    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <>
      <IconButton
        color="inherit"
        onClick={() => setOpen(prev => !prev)}
        sx={{
          mr: 1,
          display: 'inline-flex',
        }}>
        <AppsIcon color="primary" />
      </IconButton>
      {open && (
        <iframe
          ref={iframeRef}
          id="marketplaceWidget"
          src={
            import.meta.env.VITE_MARKETPLACE_WIDGET_URL ||
            'https://applications-marketplace-widget.signalos.io/'
          }
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            position: 'fixed',
            left: 0,
            top: 0,
            zIndex: 50,
          }}
          onLoad={sendMessage}
        />
      )}
    </>
  );
}
